import React from 'react';
import { CPC_DEFINITIONS } from '../constants';

const TransparencyPanel = ({
  transparency,
  showTransparency,
  setShowTransparency,
  setQuery,
  handleSearch,
  source
}) => {
  return (
    <>
            {transparency && (
  <div style={{
    marginBottom: '24px',
    padding: '16px',
    backgroundColor: '#f0f9ff',
    border: '1px solid #bae6fd',
    borderRadius: '8px'
  }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
      <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1d2934', margin: 0 }}>
        🔍 Search Strategy
      </h3>
      <button
        onClick={() => setShowTransparency(!showTransparency)}
        style={{
          background: 'none',
          border: 'none',
          color: '#53dafc',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: '600'
        }}
      >
        {showTransparency ? '▼ Hide' : '▶ Show'}
      </button>
    </div>
    
    {showTransparency && (
      <div>
        <p style={{ fontSize: '14px', color: '#474f58', marginBottom: '12px', lineHeight: '1.6' }}>
          {transparency.search_strategy}
        </p>
        
        {transparency.cpc_codes && transparency.cpc_codes.length > 0 && (
          <div style={{ marginBottom: '12px' }}>
            <p style={{ fontSize: '13px', color: '#5e778a', marginBottom: '6px', fontWeight: '600' }}>
              Patent Classifications:
            </p>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              {transparency.cpc_codes.map((code, idx) => (
                <button
                  key={idx}
                  onClick={() => {
                    setQuery(code);
                    handleSearch(null, code, source);
                  }}
                  style={{
                    background: '#53dafc',
                    color: 'white',
                    padding: '8px 16px',
                    borderRadius: '12px',
                    fontSize: '12px',
                    fontWeight: '600',
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = '#2eb8e6';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = '#53dafc';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  {code} {CPC_DEFINITIONS[code] ? `- ${CPC_DEFINITIONS[code]}` : ''}
                </button>
              ))}
            </div>
          </div>
        )}
        
        <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #bae6fd' }}>
          <p style={{ fontSize: '13px', color: '#5e778a', marginBottom: '4px', fontWeight: '600' }}>
            Why these results?
          </p>
          <p style={{ fontSize: '13px', color: '#474f58', lineHeight: '1.6', margin: 0 }}>
            {transparency.reasoning}
          </p>
        </div>
      </div>
    )}
  </div>
)}
    </>
  );
};

export default TransparencyPanel;
